// 表示位置は呼出時に指定するのでpositionなどは不要

const Tooltip = ({ label, weight = '600' }: { label: string; weight?: string }) => {
  return (
    <div className='grid min-h-[42px] w-fit place-items-center rounded-md border border-gray-200 bg-white p-3'>
      <div
        className='break-all leading-normal'
        style={{ fontWeight: weight }}
      >
        {label}
      </div>
    </div>
  );
};

export default Tooltip;
